
const state = {
  paymentsToggleHeaders: [
    { id: 'payment_date', display: true },
    { id: 'balance', display: true }
  ]
}

const actions = {
  TOGGLE_HEADERS: ({ commit }, { resource, columnId }) => {
    commit('TOGGLE_HEADERS', { resource, columnId })
  }
}

const mutations = {
  TOGGLE_HEADERS: (state, { resource, columnId }) => {
    const headers = state[`${resource}ToggleHeaders`]

    state[`${resource}ToggleHeaders`] = headers.map(e => {
      if (e.id === columnId) {
        return {...e, display: !e.display}
      }
      return e
    })
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
